"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const production_statistic_types_1 = require("./production-statistic.types");
const prod_statictic_1 = require("services/report/prod-statictic");
const getDataGrid = ({ dataStates, start_date, end_date }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, prod_statictic_1._getReportProdStatistic)(dataStates, start_date, end_date);
    if (response.isError) {
        dispatch({
            type: production_statistic_types_1.productionStatisticTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { modified_date: new Date(item.modified_date), gate_in: new Date(item.gate_in).getFullYear() ===
                        2006 ? '' : new Date(item.gate_in), gate_out: new Date(item.gate_out).getFullYear() ===
                        2006 ? '' : new Date(item.gate_out), main_entrance_in: new Date(item.main_entrance_in).getFullYear() ===
                        2006 ? '' : new Date(item.main_entrance_in) });
            }),
        };
        dispatch({ type: production_statistic_types_1.productionStatisticTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_PAGE_CHANGE, payload });
});
const onFilterDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_FILTER_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_MUTATION_CLICK, payload });
};
const onDateChange = (payload) => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_DATE_CHANGE, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.ON_SORT_CHANGE, payload });
};
const onSetIsLoading = payload => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.SET_IS_LOADING, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: production_statistic_types_1.productionStatisticTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const exportDocuments = ({ dataStates, start_date, end_date, type }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, prod_statictic_1._exportReportProdStatistic)(dataStates, start_date, end_date, type);
    if (response.isError) {
        dispatch({
            type: production_statistic_types_1.productionStatisticTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: production_statistic_types_1.productionStatisticTypes.SET_EXPORT_DOCUMENTS_URL, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: production_statistic_types_1.productionStatisticTypes.CLEAR_EXPORT_DOCUMENTS_URL, payload: '' });
};
exports.default = {
    getDataGrid,
    onCloseError,
    onSortChange,
    onDateChange,
    onFilterChange,
    onSetIsLoading,
    onClickMutation,
    onDataStateChange,
    exportDocuments,
    clearDocuments,
    onFilterDataStateChange,
};
